import { useQuery } from "@tanstack/react-query";
import { fetchCategoryAllSeries } from "../api/fetchCategoryAllSeries";

export const useCategoryAllSeries = (body, enabled = true) => {
  const { data, error, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["categoryAllSeries", body],
    queryFn: () => fetchCategoryAllSeries(body),
    enabled: !!body && enabled,
  });

  return {
    data: data?.result || null,
    error,
    isLoading: isLoading || isFetching,
    refetch,
  };
};

